<div class="main-box">
    <div class="row">
        <div class="col-lg-12">
            <div class="infographic-box">
                <form #filesForm="ngForm" novalidate>
                    <p>Available Documents:</p>
                    <div class="row" *ngIf="!isLoading">
                        <div class="col-xs-10">
                            <div class="col-xs-4" *ngFor="let file of files" style="margin: 10px 0px">
                                <div class="name">
                                    <div class="checkbox-nice">
                                        <input type="checkbox" class="access" [id]="file.name"
                                            [(ngModel)]="file.isSelected" [name]="'file_' + file.name" />
                                        <label class="oneemfontsize" [for]="file.name">
                                            {{ file.name }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-2"></div>
                    </div>
                    <div class="row" *ngIf="isLoading">
                        <div class="col-xs-12">
                                <div class="skeleton-heading skeleton-loading" style="width: 35%; margin-bottom: 14px;"></div>
                                <div *ngFor="let row of [0, 1, 2]" style="margin-bottom: 16px;">
                                    <div class="skeleton-paragraph skeleton-loading" style="width: 20%; margin-bottom: 8px;"></div>
                                    <div class="skeleton-loading" style="height: 34px; width: 100%;"></div>
                                </div>
                            </div>
                    </div>

                    <div class="row" *ngIf="!isLoading">
                        <div class="col-xs-12 text-right">
                            <div class="clearfix">
                                <button type="button" class="btn btn-danger mr-2" [disabled]="isExportingInProgress"
                                    (click)="cancel()">
                                    Cancel
                                </button>

                                <button type="button" class="btn btn-success" *ngIf="!isExportingInProgress"
                                    [disabled]="files.length === 0" (click)="exportFiles()">
                                    Export
                                </button>

                                <button type="button" class="btn btn-success" *ngIf="isExportingInProgress"
                                    [disabled]="isExportingInProgress">
                                    Exporting...
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>